export default {
  DEFAULT_SEARCH_PER_BASE: {
    22801207: {
      F_2: '*',
    },
  },
};
